import React from 'react';
import { TextField } from '@mui/material';

const formatDigitsToHHMM = (val) => {
  const digits = String(val || '').replace(/\D/g, '').slice(0, 4);
  if (digits.length <= 2) return digits;
  if (digits.length === 3) return `${digits.slice(0, 2)}:${digits.slice(2, 3)}`;
  return `${digits.slice(0, 2)}:${digits.slice(2, 4)}`;
};

/**
 * Time input: digits only, auto-format HH:MM, colon auto-skipped
 */
const TimeInput = ({ value, onChange, onBlur, error, helperText, label, placeholder = 'HHMM', ...rest }) => {
  const handleKeyDown = (e) => {
    if (e.key === ':') e.preventDefault();
  };

  const handleChange = (e) => {
    const raw = e.target.value;
    const digits = raw.replace(/\D/g, '');
    const formatted = formatDigitsToHHMM(digits.slice(0, 4));
    onChange({ ...e, target: { ...e.target, value: formatted } });
  };

  return (
    <TextField
      {...rest}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      onKeyDown={handleKeyDown}
      error={error}
      helperText={helperText}
      inputProps={{ maxLength: 5, inputMode: 'numeric' }}
    />
  );
};

export default TimeInput;
